import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import OpeningHours from './components/OpeningHours';
import LocationSection from './components/LocationSection';
import ContactSection from './components/ContactSection';
import Header from './components/Header';
import Footer from './components/Footer';
import MobileStickyBar from './components/MobileStickyBar';

const RwanCutHomePage = () => {
  const [language, setLanguage] = useState('de');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('rwan-cut-language') || 'de';
    setLanguage(savedLanguage);
  }, []);

  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('rwan-cut-language', newLanguage);
  };

  return (
    <>
      <Helmet>
        <title>{language === 'de' ? 'RWAN CUT - Premium Barbershop in Bochum | Moderne Schnitte & Bartstyling' : 'RWAN CUT - Premium Barbershop in Bochum | Modern Cuts & Beard Styling'}</title>
        <meta 
          name="description" 
          content={language === 'de' ? 'Premium Barbershop in Bochum. Moderne Schnitte, Bartstyling, klassische Rasuren. Termine nur über WhatsApp oder Telefon. Hellweg 15, 44787 Bochum.' : 'Premium barbershop in Bochum. Modern cuts, beard styling, classic shaves. Appointments via WhatsApp or phone only. Hellweg 15, 44787 Bochum.'} 
        />
        <meta name="keywords" content="RWAN CUT, Barbershop Bochum, Friseur Bochum, Moderne Schnitte, Bartstyling, Klassische Rasuren" />
        <meta property="og:title" content={language === 'de' ? 'RWAN CUT - Premium Barbershop Bochum' : 'RWAN CUT - Premium Barbershop Bochum'} />
        <meta property="og:description" content={language === 'de' ? 'Moderne Schnitte • Bartstyling • Klassische Rasuren in Bochum' : 'Modern Cuts • Beard Styling • Classic Shaves in Bochum'} />
        <meta property="og:type" content="business.business" />
        <meta property="og:url" content="https://rwancut.de" />
        <meta property="og:image" content="/assets/images/e75f4f8f-2e2c-47d5-8be6-070fec062583-1755963588204.jpeg" />
        
        {/* Schema.org structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "HairSalon",
            "name": "RWAN CUT",
            "description": language === 'de' ? "Premium Barbershop in Bochum" : "Premium barbershop in Bochum",
            "url": "https://rwancut.de",
            "telephone": "+491726060056",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Hellweg 15",
              "addressLocality": "Bochum",
              "postalCode": "44787",
              "addressCountry": "DE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 51.4818,
              "longitude": 7.2162
            },
            "openingHours": [
              "Mo-Sa 09:00-19:00"
            ],
            "priceRange": "€€",
            "image": "/assets/images/e75f4f8f-2e2c-47d5-8be6-070fec062583-1755963588204.jpeg",
            "sameAs": [
              "https://instagram.com/rwan.cut"
            ]
          })}
        </script>
      </Helmet>

      <div className="min-h-screen bg-primary">
        {/* Header with Navigation */}
        <Header language={language} onLanguageChange={handleLanguageChange} />

        {/* Hero Section */}
        <HeroSection language={language} />

        {/* Services & Prices Section */}
        <ServicesSection language={language} />

        {/* Opening Hours Section */}
        <OpeningHours language={language} />

        {/* Location Section */}
        <LocationSection language={language} />

        {/* Contact Section */}
        <ContactSection language={language} />

        {/* Footer */}
        <Footer language={language} />

        {/* Mobile Sticky Bar */}
        <MobileStickyBar language={language} />
      </div>
    </>
  );
};

export default RwanCutHomePage;